import { Badge } from '@apollo/orbit';
import { startCase } from 'lodash';
import React from 'react';

import { useQueryParam } from 'src/hooks/useQueryParam';
import {
  TimeRangeOption,
  printTimeRangeLabel,
} from 'src/lib/config/timeRangeOptions';

export const DateRangeBadge = () => {
  const range = useQueryParam('range');

  return (
    <Badge variant="info">
      {range !== undefined
        ? startCase(printTimeRangeLabel(range as TimeRangeOption))
        : 'Last day'}
    </Badge>
  );
};
